import React from 'react';
import Enter2FACode from '../Shared/Enter2FACode';

const TwoFACheck = (): JSX.Element => {
  return <Enter2FACode isPasswordReset internalRedirectTo='/Recovery/RequestPasswordReset' />;
};

export default TwoFACheck;
